import { render, staticRenderFns } from "./TimetableCreate.vue?vue&type=template&id=fc8484ec"
import script from "../../controllers/timetable/timetable-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/timetable/timetable-create.js?vue&type=script&lang=js&external"
import style0 from "./TimetableCreate.vue?vue&type=style&index=0&id=fc8484ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports